export const LISTEN = '@trybeapp/ui/CopyInventoryProductOverlayReducer/LISTEN'
